
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"4","height":"15","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M2.287 1.812h1.39V.978h-1.39zM.897 2.644h1.39v-.833H.897zM2.287 3.479h1.39v-.834h-1.39zM.897 4.312h1.39v-.833H.897zM2.287 5.145h1.39v-.833h-1.39zM.897 5.98h1.39v-.834H.897zM2.287 6.813h1.39V5.98h-1.39zM.897 7.647h1.39v-.834H.897zM2.287 8.48h1.39v-.833h-1.39zM.897 9.314h1.39v-.833H.897zM2.287 10.148h1.39v-.834h-1.39zM.897 10.982h1.39v-.834H.897zM2.843 13.205c0 .306-.25.556-.556.556a.557.557 0 01-.555-.556v-.556h1.11v.556zM.898 11.538v2.223c0 .611.5 1.111 1.112 1.111h.555c.61 0 1.112-.5 1.112-1.111v-2.223H.897z"}})])])
          )
        }
      }
    